import { gsap } from 'gsap';
export default function HeroSlider() {
	const heroslider = $('.heroSlider__heroSlider');
	const herosliderSettings = {
		dots: true,
		autoplay: true,
		autoplaySpeed: 7000,
		speed: 500,
		infinite: false,
		slideToShow: 1,
		slideToScroll: 1,
		pauseOnHover: false,
		touchMove: false,
		arrows: false,
		cssEase: 'ease',
		accessibility: true,
		cssEase: 'ease-in-out',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					dots: false,
					swipeToSlide: true,
				},
			},
		],
	};

	if (heroslider.length > 0) {
		heroslider.slick(herosliderSettings);
		gsap.to('.heroSlider', 0.5, {
			opacity: 1,
			ease: 'power4.out',
			delay: 0.5,
		});
	}

	heroslider.on(
		'beforeChange',
		function (event, slick, currentSlide, nextSlide) {
			let slide = document.querySelector(
				'.slick-slide[data-slick-index="' + nextSlide + '"]'
			);
			let slideText = slide.querySelector('.heroSlider__textContent');
			const tlSlider = gsap.timeline();
			if (tlSlider && slideText) {
				tlSlider.from(slideText, 1.5, {
					y: '150px',
					ease: 'power4.out',
					delay: 0.5,
					opacity: 0,
				});
			}
		}
	);
}
